import React from "react";

/**
 * TradeMe-style form section wrapper — a labeled heading + separator +
 * content column. Matches the reference "Post Your Ad" layout: no boxes
 * or coloured backgrounds inside the outer card, just a firm label and
 * a light divider between sections.
 */
export default function FormSection({ title, children, testId }) {
  return (
    <section
      data-testid={testId}
      className="pt-6 border-t border-subtle"
    >
      {title && (
        <h2 className="font-display text-xl font-bold text-slate-800 mb-4">
          {title}
        </h2>
      )}
      <div className="space-y-4">{children}</div>
    </section>
  );
}
